import { ChangeDetectionStrategy, Component, inject, NgModule } from '@angular/core';
import { NgxsModule, select } from '@ngxs/store';
import { BasicPage, HeaderComponent, NewsletterComponent, TrainingType, WwwRouteSlug } from '@pro-connect/shared';
import { ProEducationState } from './pro-education.state';
import { TrainingsListComponent } from 'shared/src/pages/core/components/trainings-list/trainings-list.component';
import { PillarTopComponent } from '../../../pillars/components/pillar/components/pillar-top/pillar-top.component';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@NgModule({
  imports: [NgxsModule.forFeature([ProEducationState])],
})
class ProEducationStateLazyModule {}

@Component({
  templateUrl: './pro-education.component.html',
  styleUrls: ['./pro-education.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProEducationStateLazyModule,
    HeaderComponent,
    NewsletterComponent,
    TrainingsListComponent,
    PillarTopComponent,
  ],
})
export class ProEducationComponent extends BasicPage {
  public override readonly loading = select(ProEducationState.loading);

  public readonly TrainingType = TrainingType;
  public readonly WwwRouteSlug = WwwRouteSlug;
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this._pushLayer();
  }

  public scrollToContent(view: HTMLDivElement): void {
    view.scrollIntoView({ behavior: 'smooth' });
  }

  private _pushLayer(): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: 'pl',
      country: 'Pl',
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'product selector page',
      geoIPLocation: 'Pl',
      uiLoggedStatus: !!this.user() ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
